<template>
  <div class="cpo-artist-index container">
    <div class="my-3">
      <router-link :to="{ name: 'about-index' }" class="nav-link"><v-icon left>mdi-arrow-left</v-icon> {{ $t("about.return") }}</router-link>
    </div>
    <h1 class="nav-title">{{ $t("about.artist") }}</h1>
    <div class="cpo-artist-list">
      <div class="category">
        <v-list dense>
          <v-list-item v-for="(item, i) in categories" :key="i">
            <v-list-item-content>
              <v-list-item-title>{{ item }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </div>
      <div class="layout flex-wrap">
        <div class="cpo-artist-card" v-for="item in items" :key="item.id">
          <div class="inner">
            <img :src="item.image" style="width: 100%" />
            <h5>{{ item.name }}</h5>
            <p>{{ item.title }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      items: [],
      categories: ["第一小提琴", "第二小提琴"]
    };
  },
  created() {
    this.$axios.post("/artist/list", { filter: [], sort: [{ field: "date", asc: false }], pageSize: 100 }).then((data) => {
      this.items = data;
    });
  }
};
</script>

<style lang="scss">
.cpo-artist-index {
  .cpo-artist-list {
    display: flex;
    .category {
      display: none;
    }
    .cpo-artist-card {
      flex: 1 0 50%;
      max-width: 50%;
      > .inner {
        padding: 12px;
        text-align: center;
      }
    }
  }
}
@media (min-width: 960px) {
  .cpo-artist-index {
    .cpo-artist-list {
      .cpo-artist-card {
        flex: 1 0 33.33333%;
        max-width: 33.33333%;
        > .inner {
          padding: 16px;
        }
      }
    }
  }
}
@media (min-width: 1264px) {
  .cpo-artist-index {
    .cpo-artist-list {
      display: flex;
      .category {
        display: block;
        min-width: 260px;
        max-width: 260px;
      }
      .cpo-artist-card {
        flex: 1 0 25%;
        max-width: 25%;
        > .inner {
          padding: 24px;
        }
      }
    }
  }
}
</style>
